import React, { forwardRef } from 'react'
import { bool, string } from 'prop-types'
import shallowObjectToQuery from '@/lib/shallow-object-to-query'

export const YouTubeEmbedFallbackUrl = (videoId) =>
  `https://www.youtube.com/watch?v=${videoId}`

const YouTubeEmbed = forwardRef(
  ({ hideControls, start, videoId, autoplay, loop }, ref) => {
    const srcPrefix = 'https://www.youtube.com/embed/'
    const query = {
      modestbranding: 1,
      enablejsapi: 1,
      playsinline: 1,
      rel: 0, // https://developers.google.com/youtube/player_parameters#release_notes_08_23_2018
      ...(hideControls && { controls: 0 }),
      ...(start && { start }),
      ...(autoplay && { autoplay: 1, mute: 1 }),
      ...(loop && { loop: 1, playlist: videoId })
    }

    return (
      <iframe
        ref={ref}
        title="Embedded YouTube video"
        src={`${srcPrefix}${videoId}?${shallowObjectToQuery(query)}`}
        width="560"
        height="315"
        frameBorder="0"
        allowFullScreen
        style={{ backgroundColor: 'black' }}
      />
    )
  }
)

YouTubeEmbed.propTypes = {
  hideControls: bool,
  start: string,
  videoId: string.isRequired,
  autoplay: bool,
  loop: bool
}

export default YouTubeEmbed
